import React, { useEffect, useState } from "react";
import { View, Platform, StyleSheet } from "react-native";

import { Button, Text } from "components";

import { colors } from "assets/constants";
import tinycolor from "tinycolor2";

interface CounterProps {
  onChange: (count: number) => void;
  defaultValue?: number;
  maxCount?: number;
  minCount?: number;
  disableAction?: boolean;
  counterStep?: number;
}

const Counter: React.FC<CounterProps> = ({
  defaultValue = 1,
  onChange,
  maxCount,
  minCount = 1,
  disableAction,
  counterStep = 1,
}) => {
  const [countState, setCountState] = useState(defaultValue);

  useEffect(() => {
    setCountState(defaultValue);
  }, [defaultValue]);

  const _onMinus = () => {
    if (countState === minCount) {
      return;
    }

    const newCount = countState - counterStep;
    setCountState(newCount);
    onChange(newCount);
  };

  const _onPlus = () => {
    if (countState === maxCount) {
      return;
    }

    const newCount = countState + counterStep;
    setCountState(newCount);
    onChange(newCount);
  };

  const styles = StyleSheet.create({
    counter: { flexDirection: "row" },

    count: {
      width: 50,
      height: 35,
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.lightButtons,
    },
  });
  return (
    <View style={styles.counter}>
      <Button
        disabled={disableAction}
        style={{ opacity: disableAction ? 0.5 : 1 }}
        onPress={_onMinus}
        square={35}
        bgColor={colors.transparent}
        icon={{
          size: 22,
          name: "minus",
          color: tinycolor(colors.danger).darken(12).toString(),
        }}
      />

      <View style={styles.count}>
        <Text
          top={Platform.OS === "android" ? 4 : 0}
          size={"xxl"}
          weight="extraBold"
          style={{ letterSpacing: 1.1 }}
          color={tinycolor(colors.theme).darken(15).toString()}
        >
          {countState}
        </Text>
      </View>

      <Button
        disabled={disableAction}
        style={{ opacity: disableAction ? 0.5 : 1 }}
        onPress={_onPlus}
        square={35}
        bgColor={colors.transparent}
        icon={{
          size: 22,
          name: "plus",
          color: tinycolor(colors.success).darken(12).toString(),
        }}
      />
    </View>
  );
};

export default Counter;
